import { axiosEduServer } from "../utils/configAxios";

export const crearProvincia = (data) => {
  return axiosEduServer.post('/provincia', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarProvincia = (id, data) => {
  return axiosEduServer.put(`/provincia/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarProvincia = (id) => {
  return axiosEduServer.delete(`/provincia/${id}`).then(({ data }) => data).catch((err) => { throw err });
}
export const getOneProvincia = (id) => {
  return axiosEduServer.get(`/provincia/${id}`).then(({ data }) => data).catch((err) => { throw err });
}
export const getAllProvincias = () => {
  return axiosEduServer.get('/provincia').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllProvinciasByIdDepartamento = (idDepartamento) => {
  return axiosEduServer.get(`/provincia/idDepartamento/${idDepartamento}`).then(({ data }) => data).catch((err) => { throw err });
};